import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260618-widerruf",
        datum: "18.06.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.FEATURE,
        title: "Neue Widerrufsfunktion für Online-Kursanmeldungen",
        lizenz: [LizenzEnum.KURSE],
        content: [
            "Zum 19.06.2026 treten neue gesetzliche Anforderungen für online abgeschlossene Verträge in Kraft."
            + " Das Update für HiOrg-Server KURSE ist umgesetzt und steht ab sofort zur Verfügung.",
            "Neu hinzugekommen sind:<br>"
            + "<ul class='tw:list-inside tw:list-disc'>"
            + "<li>Widerrufsfunktion für öffentliche Kursangebote</li>"
            + "<li>Entsprechende Einstellungen im Bereich \"Öffentl. Kursangebote & TN-Anmeldung\"</li>"
            + "<li>Option für Kurse mit kurzfristigem Beginn</li>"
            + "</ul>",
            "Bitte prüft die neuen Einstellungen nach dem Update und passt die hinterlegten Texte sowie die verfügbaren"
            + " Optionen bei Bedarf an eure Anforderungen an."
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/?p=11564",
            },
        ],
    },
];

export {
    insights,
};
